import DonationRefundPolicy from "./DonationRefundPolicy";

export default DonationRefundPolicy;
